export default {
  Loading: {
    en: 'Loading',
    ja: '読み込み中'
  },
  ConnectWallet: {
    en: 'Connect Wallet',
    ja: 'ウォレットを接続する'
  },
  Available: {
    en: 'Available',
    ja: '利用可能'
  }
}